import { createFileRoute } from "@tanstack/react-router";
import SiteMapPage from "@/pages/SiteMapPage";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/sitemap")({
  head: () => ({
    meta: [
      { title: "Site Map | All Statlign Pages" },
      { name: "description", content: "Complete Statlign site map: prediction feeds, league and competition hubs, betting markets, guides, performance data, and our privacy, terms, about and contact pages." },
      { property: "og:title", content: "Site Map | All Statlign Pages" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Complete Statlign site map: prediction feeds, league and competition hubs, betting markets, guides, performance data, and our privacy, terms, about and contact pages." },
      { name: "twitter:title", content: "Site Map | All Statlign Pages" },
      { name: "twitter:description", content: "Complete Statlign site map: prediction feeds, league and competition hubs, betting markets, guides, performance data, and our privacy, terms, about and contact pages." },
    ],
  }),
  component: () => (
    <MainLayout>
      <SiteMapPage />
    </MainLayout>
  ),
});
